import { useRecoilValue } from 'recoil';
import dataManagementEntityAtom from 'ProjectManager/DataManagement/Common/recoil/dataManagementEntity/dataManagementEntityAtom';
import dataManagementEntities from 'ProjectManager/DataManagement/Common/constants/dataManagementEntities';
import useHideTemplateQuestionFunction from 'ProjectManager/DataManagement/Questionnaire/components/Question/ShowHideControl/hooks/hideQuestionFunctions/useHideTemplateQuestionFunction';
import useHideProjectQuestionFunction from 'ProjectManager/DataManagement/Questionnaire/components/Question/ShowHideControl/hooks/hideQuestionFunctions/useHideProjectQuestionFunction';

const useHideQuestionFunction = (questionId, isCustomQuestion) => {
    const dataManagementEntity = useRecoilValue(dataManagementEntityAtom);

    const dataFromProject = useHideProjectQuestionFunction(
        questionId,
        isCustomQuestion,
    );

    const dataFromTemplate = useHideTemplateQuestionFunction(
        questionId,
        isCustomQuestion,
    );

    if (dataManagementEntity === dataManagementEntities.PROJECT) {
        return dataFromProject;
    }

    if (dataManagementEntity === dataManagementEntities.TEMPLATE) {
        return dataFromTemplate;
    }

    return () => {};
};

export default useHideQuestionFunction;
